import GamesListComponent from './games_list_component';
import LiveCasinoGamesListComponent from './live_casino_games_list_component';
import WidgetComponent from './widget_component';

export default {
  GamesListComponent,
  LiveCasinoGamesListComponent,
  WidgetComponent,
};
